var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "432.000000pt",
    height: "432.000000pt",
    viewBox: "0 0 432.000000 432.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,432.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623 4290 c-107 -22 -179 -73 -222 -155 -21 -39 -21 -47 -21 -782 0 -501 3 -744 10 -748 6 -4 223 -24 483 -46 511 -42 522 -44 559 -104 16 -27 18 -56 18 -300 0 -250 -2 -272 -20 -302 -36 -60 -44 -61 -557 -104 -261 -21 -479 -42 -484 -45 -5 -3 -9 -325 -9 -747 0 -735 0 -743 21 -782 29 -56 75 -101 126 -125 62 -29 262 -29 350 1 71 23 2995 1747 3058 1802 37 32 113 143 104 151 -2 2 -59 -1 -126 -7 -108 -9 -125 -8 -148 7 -25 16 -25 18 -25 151 0 175 -4 171 171 156 68 -6 124 -9 126 -8 9 9 -45 91 -87 133 -74 74 -2981 1790 -3095 1827 -92 30 -172 40 -232 27z m1522 -1835 c287 -23 282 -22 326 -62 l39 -35 0 -202 0 -202 -29 -31 c-38 -42 -69 -49 -319 -68 -268 -22 -322 -19 -362 20 l-30 29 0 251 c0 248 0 252 23 272 54 49 75 51 352 28z m1005 -81 c107 -8 205 -17 217 -20 49 -10 53 -23 53 -204 l0 -169 -27 -15 c-17 -8 -105 -20 -224 -30 -264 -22 -271 -21 -308 10 l-31 26 2 186 3 186 34 23 c40 27 34 27 281 7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadview);
export default __webpack_public_path__ + "static/media/roadview.309504a1.svg";
export { ForwardRef as ReactComponent };